// IE 2026 11 03 / ODOO-350449 (ie-dm7 #128926: порции 15, бюджет 5 с, группы только по Alt, лёгкий запрос)
// Лёгкий запрос фоновых read-методов виджета отчёта: signal_chains_batch (предзагрузка цепочек сигналов, AttrGrid sigPrefetch_send) и stock_cells_batch (виды ячеек запаса,
// AttrGrid stk_send). Замер p260 (dev02, Баланс закупівель 1fxa_001, бандл -218): запрос порции 893 КБ при уже исключённых _doc и view — запись виджета 801 КБ
// (doc.params.data_layout2 497 КБ, doc.viewList 187 КБ, conditional_format 31 КБ, viewParams 18 КБ, option_groups 15 КБ, data_layout2_fields 5 КБ), workspace_params 45 КБ,
// fast_entry 6,5 КБ; запрос stock_cells_batch — те же 856–860 КБ.
// Что бэк читает из записи (origin/main-2024-12, grep по common_modules):
//   signal_chains_batch → cell_passport.build(story_only): id; doc.params WHERE (_report_where / _report_calc_nodes), source_segments / approval_segment (plan_passport.report_segments),
//     version, fieldsMapping (attrs.processing_fieldsMapping), даты;
//   stock_cells_batch → stock_cells._version_of: plan_passport.ds_version / approval_wiring.report_version — doc.params approval_version, version, source_segments[].version, fieldsMapping;
//   раскладку DL2, колонки viewList, правила оформления, группы опций и viewParams — ни один из двух. workspace_params (версия, чипсы, селекторы стола) остаются целиком.
// fast_entry (словари ссылочных колонок inlineIS) нужен только select — у read-методов ключ снимается (бэк: selectorsOnce по умолчанию True, словари к ответу не прикладываются).
// Запрос без view и без widget_cache_key — бэк виджет в кэш не кладёт, урезанная копия дальше запроса не живёт. Живая запись не меняется.
// Выключатель fe.data.readMethodsLight (дефолт ВКЛ; false — запись целиком без _doc, fast_entry — как у всех запросов). Тест — tests/unit/readMethodLight.test.mjs
export const READ_LIGHT_FLAG = 'fe.data.readMethodsLight'
export const READ_LIGHT_METHODS = ['signal_chains_batch', 'stock_cells_batch']
const DOC_DROP = ['viewList', 'viewParams', 'tooltip', 'tooltip_uk', 'tooltip_ru', 'llm_instruction']
const PARAMS_DROP = ['data_layout2', 'data_layout2_fields', 'conditional_format', 'option_groups']
const isObj = (v) => v != null && typeof v === 'object' && !Array.isArray(v)

export function readLight_on(setting) {
    try { return typeof setting !== 'function' || setting(READ_LIGHT_FLAG, true) !== false } catch (e) { return true }
}

// урезанная копия записи: без _doc, doc без DOC_DROP, doc.params без PARAMS_DROP (значения — те же ссылки); не объект — как есть; без doc — копия без _doc. Вход не мутируется
export function readLight_record(record) {
    if (!isObj(record)) return record
    const out = {}
    for (const k of Object.keys(record)) if (k !== '_doc') out[k] = record[k]
    if (!isObj(record.doc)) return out
    const doc = {}
    for (const k of Object.keys(record.doc)) if (!DOC_DROP.includes(k)) doc[k] = record.doc[k]
    if (isObj(record.doc.params)) {
        const params = {}
        for (const k of Object.keys(record.doc.params)) if (!PARAMS_DROP.includes(k)) params[k] = record.doc.params[k]
        doc.params = params
    }
    out.doc = doc
    return out
}

// поля action фонового read-метода: { record: урезанная копия, fast_entry: undefined } (mainStore.get_widget_to_transfer берёт action.record как есть; ...action в теле запроса
// перекрывает fast_entry, JSON.stringify ключ с undefined опускает). Метод не из READ_LIGHT_METHODS / флаг выключен — {} (запрос прежний)
export function readLight_fields(method, record, setting) {
    if (!READ_LIGHT_METHODS.includes(method) || !readLight_on(setting)) return {}
    return { record: readLight_record(record), fast_entry: undefined }
}
